import React, { FC } from 'react';

interface SVGEmailIconProps {
  width?: string;
  height?: string;
  color?: string;
}

const SVGEmailIcon: FC<SVGEmailIconProps> = ({
  width = '32',
  height = '32',
  color = 'black',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_195_370)">
      <path
        d="M7.30216 12.7481C6.93045 12.3811 6.89715 11.7491 7.22746 11.3361C7.55686 10.9231 8.12567 10.8851 8.49738 11.2531L14.8038 17.481C15.486 18.155 16.5138 18.155 17.196 17.481L23.5024 11.2531C23.8732 10.8861 24.442 10.9231 24.7723 11.3361C25.1026 11.7491 25.0693 12.3811 24.6976 12.7481L21.553 15.8541L24.7273 19.284C25.0837 19.668 25.0918 20.302 24.7453 20.698C24.5689 20.899 24.3349 21 24.1 21C23.8741 21 23.6473 20.906 23.4727 20.717L20.2038 17.1861L18.3912 18.977C17.7099 19.65 16.8549 19.986 15.9999 19.986C15.1449 19.986 14.2899 19.65 13.6086 18.977L11.7959 17.1861L8.52708 20.717C8.35248 20.906 8.12567 21 7.89977 21C7.66487 21 7.43176 20.899 7.25446 20.698C6.90886 20.302 6.91606 19.668 7.27246 19.284L10.4468 15.8541L7.30216 12.7481ZM4 20.8889C4 22.6044 5.34571 24 7 24H25C26.6543 24 28 22.6044 28 20.8889V11.1111C28 9.39644 26.6543 8 25 8H7C5.34571 8 4 9.39644 4 11.1111V20.8889Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_195_370">
        <rect width="24" height="16" fill="white" transform="translate(4 8)" />
      </clipPath>
    </defs>
  </svg>
);

export default SVGEmailIcon;
